import styled from "styled-components";

export const LoadingStatusContainer = styled.div`
  font-weight: bold;
  color: #fff;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 95%;
  padding: 20px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 98%;
  margin: 10px;
`;
